import { useTranslations } from "next-intl";
import { ProgressCustom } from "@/components/progress";
import { Button } from "@/components/ui/button";
import { CardContent } from "@/components/ui/card";
import type {
  DiscountProgressDisplayTier,
  DiscountTierData,
} from "./use-discount-cart-progress";

type DiscountCartProgressContentProps = {
  isAddDaysDisabled: boolean;
  nextTier: DiscountTierData | null;
  onAddDays: () => Promise<void>;
  progressTiers: DiscountProgressDisplayTier[];
  progressValue: number;
};

export const DiscountCartProgressContent = ({
  isAddDaysDisabled,
  nextTier,
  onAddDays,
  progressTiers,
  progressValue,
}: DiscountCartProgressContentProps) => {
  const t = useTranslations();
  const handleAddDaysClick = () => {
    onAddDays();
  };

  return (
    <CardContent className="p-4">
      <ProgressCustom value={progressValue} tiers={progressTiers} />
      <div className="bg-(image:--discount-gradient-icon) mt-4 rounded-lg p-px">
        <Button
          type="button"
          variant="outline"
          className="w-full rounded-lg border-none px-2 text-[15px] hover:text-white"
          disabled={isAddDaysDisabled}
          onClick={handleAddDaysClick}
        >
          {t("discounts.discountMessage.addDays", {
            days: nextTier?.days ?? 0,
            discount: nextTier?.discountAmountLabel ?? "0,00 zł",
          })}
        </Button>
      </div>
      <p className="pt-2 text-center text-[13px] text-gray-500">
        {t("discounts.discountMessage.description")}
      </p>
    </CardContent>
  );
};
